import React from 'react';
import './ContactCard.css';
import qrcodeImg from '../qrcode.jpg';

/**
 * 客户经理联系卡片组件
 * 基于妙多设计实现的联系卡片
 */
interface ContactCardProps {
  onClose?: () => void;
}

const ContactCard: React.FC<ContactCardProps> = ({ onClose }) => {
  return (
    <div className="contact-card">
      <div className="card-container">
        {onClose && (
          <button className="card-close" onClick={onClose}>
            ×
          </button>
        )}
        <div className="card-title">
          联系客户经理
        </div>
        
        <div className="qr-code-container">
          <img 
            src={qrcodeImg} 
            alt="企业微信二维码" 
            className="qr-code"
          />
        </div>
        
        <div className="card-description">
          扫描二维码联系您的专属客户经理
        </div>
      </div>
    </div>
  );
};

export default ContactCard;